import { AxiosError } from 'axios';

export const isAxiosError = <T>(error: any): error is AxiosError<T> =>
  error.hasOwnProperty('response') && typeof error.response !== undefined;
